import template from './template.html';
import blockBase from "../../mixins/blockBase";

export default {
    name: 'intro',
    template: template,
    mixins: [
        blockBase,
    ],
    computed: {
        blockCssClass() {
            return (this.block.image) ? 'intro-has-bg-image ' : '';
        }
    },
};